import BaseCommunicator from "./BaseCommunicator"

class AppCommunicator extends BaseCommunicator {
    constructor(appBridge) {
        super();
        init(appBridge);
    }

    async getDeviceType() {
        return (await this.getConfig()).httpHeaders["Device-Type"];
    }

    async getConfig() {
        if(this.config) return this.config;
        return new Promise((resolve, reject) => {
            broadcast("GetConfig", {}, (error, data) => {
                if (error) return reject(error);
                this.config = data;
                resolve(data);
            });
        });
    }

    disableFairtiqModal() {
        broadcast("DisableFairtiqModal", {});
    }

    openDeeplink(deeplink, url) {
        broadcast("OpenDeeplink", {
            deeplink: deeplink,
            url: url
        });
    }

    async trackPageImpression(pageName) {
        broadcast("TrackPageImpression", {
            pageName: pageName
        });
    }

    async trackEvent(action, category, label) {
        broadcast("TrackEvent", {
            action: action,
            category: category,
            label: label || ""
        });
    }
}

function init(appBridge) {
    window.nativeCallback = nativeCallback;
    window.nativeCalls = {};
    window.appBridge = appBridge;
}

/**
 *  Listen to native call without sending
 *  data to the container app
 *  @param {string} name -
 *  @param {function} callback -
 *  @returns {void}
 */
function listen(name, callback) {
    window.nativeCalls[name] = new Call(name, callback, name, null, null, Date.now(), null);
}

/**
 *  Generate uid to identify native callbacks
 *  after call when return from native app
 *  @returns {string} uid
 */
function _generateUid() {
    function s4() {
        return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
    }

    return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
}

/**
 *  Send data to the native app and listen to
 *   the response via callback
 *  @param {string} name -
 *  @param {object} dataDictionary -
 *  @param {function} callback -
 *  @returns {void}
 */
function broadcast(name, dataDictionary, callback) {
    let uid = _generateUid();
    dataDictionary = dataDictionary || {};
    let dataJSON = JSON.stringify(dataDictionary);
    console.log("[Communicator] Broadcast ", uid, name, dataJSON);
    window.nativeCalls[uid] = new Call(uid, callback, name, dataDictionary, null, Date.now(), null);
    switch (window.appBridge) {
        case "Android":
            window.NativeApp.call(uid, name, dataJSON);
            break;
        case "iOS":
            window.nativeAppCall(uid, name, dataJSON);
            break;
        case "webkit":
            window.webkit.messageHandlers.nativeAppCall.postMessage([uid, name, dataJSON]);
            break;
    }
}

/**
 *  Is called by native app.
 *  @param {boolean|string} error -
 *  @param {string} uid -
 *  @param {object} dataDictionary -
 *  @returns {void}
 */
function nativeCallback(error, uid, dataDictionary) {
    if (typeof window.nativeCalls[uid] === "undefined") {
        throw new Error("Callback from native app is not known!", uid, dataDictionary, error, this.nativeCalls);
    }
    if (typeof window.nativeCalls[uid].callback !== "function") {
        throw new Error("Callback object has no function property!", uid, dataDictionary, error, this.nativeCalls);
    }
    window.nativeCalls[uid].callback(error, dataDictionary);
}


/**
 *  Model ...
 *  @param {string} uid -
 *  @param {function} callback -
 *  @param {string} name -
 *  @param {object} requestData -
 *  @param {object} responseData -
 *  @param {number} requestTime -
 *  @param {number} responseTime -
 *  @returns {void}
 */
function Call(uid, callback, name, requestData, responseData, requestTime, responseTime) {
    this.uid = uid;
    this.callback = callback;
    this.name = name;
    this.requestData = requestData;
    this.responseData = responseData;
    this.requestTime = requestTime;
    this.responseTime = responseTime;
}

export {AppCommunicator, broadcast, Call, init}
